import React from 'react';
import { StyledModalBase } from './ModalBase.styles';
/**
 * Base modal component, powered by [react-modal](http://reactcommunity.org/react-modal/#usage)
 *
 * (Also see `ModalAdapter` in the styles file)
 *
 * Accessible element label must be included either as a string passed to `labelText`, or
 * the id of one of the children passed to `labelElement`. If a description is available,
 * pass that element’s id to the `describedBy` prop.
 */
export function ModalBase(props) {
    const { children, className, clickToDismiss, describedBy, id, node, open, preventEscDismiss, preventReturnFocus, maxWidth, } = props;
    const ariaProps = {};
    if ('labelElement' in props) {
        ariaProps['labelledby'] = props.labelElement;
    }
    if (describedBy) {
        ariaProps['describedby'] = describedBy;
    }
    return (React.createElement(StyledModalBase, { ariaHideApp: false, "data-cy": props['data-cy'], aria: ariaProps, className: className || 'baseModal', contentLabel: 'labelText' in props ? props.labelText : null, id: id, isOpen: open, node: node, onRequestClose: clickToDismiss, shouldCloseOnEsc: !preventEscDismiss, shouldReturnFocusAfterClose: !preventReturnFocus, maxWidth: maxWidth }, children));
}
//# sourceMappingURL=ModalBase.js.map